import Link from "next/link";
import SkeletonElement from "../SkeletonElement";

interface IPage {
  link?: string;
  label: string;
}

interface BreadcrumbProps {
  pages: IPage[];
  sx?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const { pages, sx } = props;
  return (
    <div
      className={`flex text-gray-500 gap-2 text-sm uppercase py-8 ${sx} overflow-hidden whitespace-nowrap text-ellipsis`}
    >
      <Link href="/" className="hover:text-icon">
        home
      </Link>
      {pages.map(({ link, label }, index) => (
        <div key={index}>
          <span className="mr-2">{`>`}</span>
          {link ? (
            <Link href={link}>
              <span
                className={` ${
                  index === pages.length - 1 ? "text-icon" : "hover:text-black"
                }`}
              >
                {label}
              </span>
            </Link>
          ) : (
            <span
              className={` ${
                index === pages.length - 1 ? "text-black" : "hover:text-black"
              }`}
            >
              {label}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export const BreadcrumbSkeleton = () => {
  return (
    <div
      className={`flex text-gray-500 gap-2 text-sm uppercase py-8 h-5 w-1/2`}
    >
      <SkeletonElement />
    </div>
  );
};

export default Breadcrumb;
